import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {
  fetchRolesSuccess,
  fetchRolesFailure,
  fetchAssignableRolesSuccess,
  fetchAssignableRolesFailure
} from '../actions/roleActions';
import Env from '../Env';

function* getRoles() {
  let headerPayload = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const roles = yield call(fetchClient, {
      url: 'users-api/v1/roles',
      headers: headerPayload,
      apiServer: Env.getApimBaseUrl()
    });
    yield put(fetchRolesSuccess(roles));
  } catch (e) {
    yield put(fetchRolesFailure());
  }
}

function* getAssignableRoles(action) {
  let headerPayload = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const roles = yield call(fetchClient, {
      url: `users-api/v1/${action.payload.grandParentCustomerNumber}/roles/assign`,
      headers: headerPayload,
      apiServer: Env.getApimBaseUrl()
    });
    yield put(fetchAssignableRolesSuccess(roles));
  } catch (e) {
    yield put(fetchAssignableRolesFailure);
  }
}

export default function* rolesSaga() {
  yield takeLatest(ActionTypes.ROLES.FETCH.REQUEST, getRoles);
  yield takeLatest(ActionTypes.ROLES.ASSIGN_ROLES.REQUEST, getAssignableRoles);
}
